import type { ReactNode } from "react";

/** Пустое место в панели проекта — курсивная строка (в барреле проекта — `Empty`). */
export function EmptyNote({ children }: { children: ReactNode }) {
  return <p className="text-[12.5px] text-fg-faint italic">{children}</p>;
}
